import styled from '@emotion/styled';

interface ContainerProps {
  containerWidth: string | undefined;
}

// Container for the modal
export const Container = styled.div<ContainerProps>`
  padding: 1rem;
  position: relative;
  width: ${({ containerWidth }) => containerWidth};
`;
